export default __webpack_public_path__ + "static/media/Bot-Mechanic.dd111d90.jpg";